import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InputMask from 'react-input-mask';
import InputPhoneCountries from './Countries';

class InputPhone extends Component {
  static propTypes = {
    accent: PropTypes.bool,
    center: PropTypes.bool,
    disabled: PropTypes.bool,
    error: PropTypes.bool,
    name: PropTypes.string,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    'data-valid': PropTypes.bool,
    placeholder: PropTypes.string,
    children: PropTypes.node,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  };

  static defaultProps = {
    accent: false,
    center: false,
    disabled: false,
    error: false,
    'data-valid': true,
    placeholder: '',
    value: '',
    name: '',
    children: null,
    onFocus: () => {},
    onChange: () => {},
    onBlur: () => {},
  };

  constructor(props) {
    super(props);

    this.state = {
      value: props.value,
      code: '+7',
    };
  }

  getMask = () => {
    if (this.state.code == '+7') {
      return '+7 (999) 999-99-99';
    }

    return `${this.state.code.replace(/9/g,"\\9")} 999 999 999 999 999`;
  };

  static getDerivedStateFromProps(props) {
    return {
      value: props.value,
    };
  }

  getInput() { 
    const {
      disabled,
      name,
      placeholder,
      onFocus,
      error,
      validator,
      required,
      showAlert,
      isPhoneCorrect
    } = this.props;
    const { value } = this.state;
    const classes = ['inp__field'];

    if (validator && required) {
      if ((!this.props['data-valid'] || error) && !validator(value) || (isPhoneCorrect !== undefined && !isPhoneCorrect)) classes.push('inp__field--error');
    } else if (!this.props['data-valid'] || error ) classes.push('inp__field--error');

    switch (true) {
      default:
        return (
          <InputMask
            disabled={disabled}
            className={classes.join(' ')}
            placeholder={placeholder}
            name={name}
            maskChar={""}
            alwaysShowMask={true}
            mask={this.getMask()}
            onChange={this.onChange}
            type="text"
            onFocus={onFocus}
            onBlur={this.onBlur}
            data-valid={this.props['data-valid']}
            value={value}
          />
        );
    }
  }

  getIcon() { 
    const {
      required,
      value,
      validator,
      error,
      isPhoneCorrect,
      showAlert
    } = this.props;


    if (validator && required && showAlert !== undefined)  {
      if (validator(value) && !showAlert && isPhoneCorrect) {
        return <div className="inp__field--success-icon" />;
      } else {
        return <div className="inp__field--error-icon" />;
      }
    } else if (validator && required && showAlert === undefined) {
      if (validator(value)) {
        return <div className="inp__field--success-icon" />;
      } else {
        return <div className="inp__field--error-icon" />;
      }
    } else if(!this.props['data-valid'] || error) return <div className="inp__field--error-icon" />;
  }

  onBlur = e => {
    const { onBlur, name } = this.props;

    this.setState({
      value: e.target.value,
    });

    if (onBlur) onBlur(e.target.value, name);
  };

  onChange = e => {
    const { onChange, name } = this.props;

    this.setState({
      value: e.target.value,
    });

    if (onChange) onChange(e.target.value, name);
  };

  render() {
    const { accent, center, error, date } = this.props;
    const classes = ['inp','inp--phone-countries'];

    if (accent) classes.push('inp--accent');
    if (center) classes.push('inp--center');
    if (error) classes.push('inp--error');
    if (date) classes.push('inp--overlay');

    return (
      /* eslint-disable */
      <label className={classes.join(' ')}>
        <InputPhoneCountries onChange={code => this.setState({code: code})} />
        {this.getInput()}
        {this.props.children}
        { this.getIcon() }
      </label>
      /* eslint-enable */
    );
  }
}

export default InputPhone;
